import React from 'react';
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import StatsSection from '../components/landing/StatsSection';
import BitcoinChart from '../components/landing/BitcoinChart';
import TradingSection from '../components/landing/TradingSection';
import PerformanceSection from '../components/landing/PerformanceSection';
import ForecastCalculator from '../components/landing/ForecastCalculator';
import AboutSection from '../components/landing/AboutSection';
import ApproachSection from '../components/landing/ApproachSection';
import Footer from '../components/landing/Footer';
import CryptoTicker from '../components/landing/CryptoTicker';
import { SmoothSection } from '../components/SmoothSection';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-black overflow-x-hidden">
      <Header />
      <main>
        {/* Hero - No transition needed, always visible first */}
        <HeroSection />
        
        {/* Stats Section - Fade up */}
        <SmoothSection animation="fade-up" delay={0}>
          <StatsSection />
        </SmoothSection>

        {/* Live Crypto Ticker - Between Stats and Bitcoin Chart */}
        <CryptoTicker />
        
        {/* Bitcoin Chart - Blur in */}
        <SmoothSection animation="blur" delay={100}>
          <BitcoinChart />
        </SmoothSection>
        
        {/* Trading Section - Scale reveal */}
        <SmoothSection animation="scale" delay={0}>
          <TradingSection />
        </SmoothSection>
        
        {/* Performance Section - Fade up */}
        <SmoothSection animation="fade-up" delay={100}>
          <PerformanceSection />
        </SmoothSection>
        
        {/* Forecast Calculator - Blur in */}
        <SmoothSection animation="blur" delay={0}>
          <ForecastCalculator />
        </SmoothSection>
        
        {/* About Section - Scale reveal */}
        <SmoothSection animation="scale" delay={100}>
          <AboutSection />
        </SmoothSection>
        
        {/* Approach Section - Fade up */}
        <SmoothSection animation="fade-up" delay={0}>
          <ApproachSection />
        </SmoothSection>
      </main>
      
      {/* Footer - Fade up */}
      <SmoothSection animation="fade-up" delay={100}>
        <Footer />
      </SmoothSection>
    </div>
  );
};

export default LandingPage;
